export default __webpack_public_path__ + "images/09cca6bf5347284aa38a69b60e080077.svg";